<template>
  <div class="py-4 border mt-3" id="policyFile">
    <div class="top new-top">
      <span>政策信息</span>
      <span class="more">更多</span>
    </div>
    <div class="ZcFileTop">
      <PillFilter
        v-model="newsType"
        :options="filterOptions"
        @change="radioChange"
      />
      <!--<div class="ml-4 ft-15 self-end" style="color:red;font-weight: 700">点击对应图片文件进行下载</div>-->
    </div>
    <div class="file-scroll">
      <div class="file-marquee gs-card flex-shrink-0 " v-for="item  in fileList" :key="item.id" @click="fileUpload(item)"
      >
        <div
            class="file-marquee-item flex flex-col items-center justify-between cursor-pointer"
            :style="opacityImg(item)"
        >
        </div>
        <p class="FJFontItem" style="color:#2196F3">{{ item.name}}</p>
        <p class="ft-12" style="width: 100px">{{ item.createTime && item.createTime.split(' ')[0] }}</p>
      </div>
    </div>

  </div>
</template>
<script>
import {
  getBookList
} from "@/api/api";
import PillFilter from '@/components/PillFilter/index.vue'
export default {
  components: { PillFilter },
  data() {
    return {
      fileList:[],
      fileTimer:null,
      newsType:"1",
      filterOptions: [
        { label: '政策', value: '1' },
        { label: '标准', value: '2' },
        { label: '报告', value: '3' }
      ],
      prodUrl:"https://shujuzichan.com/xwzx",
    };
  },
  created() {

    this.getFileList();
  },
  methods: {
    getFileList (value) {
      var formData = {};
      formData["pageNum"]=1;
      formData["pageSize"]=10;
      if (value) {
        formData["type"] = value;
      }
      getBookList(formData).then((response) => {
        this.fileList = response.rows;
        this.fileMarquee();
      });
    },
    prevFile() {
      clearInterval(this.fileTimer)
      this.fileList.unshift(this.fileList[this.fileList.length - 1])
      this.fileList.pop()
      this.fileMarquee()
    },
    radioChange(value) {
      this.getFileList(value);
    },
    fileMarquee(){
      this.fileTimer = null
      this.fileTimer = setInterval(() => {
        this.fileList.push(this.fileList[0])
        this.fileList.shift()
      }, 4000)
    },
    fileUpload (item){
      var link = document.createElement('a') // 创建一个新的链接元素
      link.href = this.prodUrl + item.url // 设置链接的 URL
      link.download = `${item.name}` // 设置下载文件的文件名
      link.click() // 模拟点击链接，触发文件下载
    },
    opacityImg(item){
      return {backgroundImage:"url("+this.prodUrl+item.image+")",backgroundSize: "100% 100%"};
    },
    nextFile(){
      clearInterval(this.fileTimer)
      this.fileList.push(this.fileList[0])
      this.fileList.shift()
      this.fileMarquee()
    }
  }
};
</script>
<style scoped>
.items-center{
  display: flex;
  align-items: center;
}
.FJFontItem{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.top {
  font-size: 16px;
  font-weight: 700;
  color: black;
  margin-bottom: 20px;
}
.file-scroll{
  display: flex;
  overflow-x: auto;
  gap: 20px;
  padding-bottom: 8px;
}
.ZcFileTop{
  display: flex;
}
  .file-marquee {
    background-color: #fff;
    width: 130px;

    & + .file-marquee {
      margin-left: 20px;
    }

    .file-marquee-item {
      height: 120px;
      width: 100px;
      margin: 5px;
      padding: 5px;
      box-shadow: 0px 2px 8px 0px rgba(3, 52, 87, 0.2);
      border-radius: 8px;
    }
    &:hover {
      border: 3px solid #f00;
      .file-marquee-item {
        img {
          transition: all 0.5s;
          transform: scale(1.1);
        }
      }
    }
  }

  :deep(.el-table .cell) {
    padding: 0;
  }

  :deep(.el-dialog__body) {
    padding: 10px 20px;
  }
.w-8{
  width:2rem
}
.more {
  float: right;
  margin-right: 10px;
}
.more:hover {
  color:red;
}
.slick-slide{
  width: 120px !important;
  margin-left: 5px;
}
.el-radio-group{
  margin-left: auto;
}
.new-top {
  margin: 20px 0 20px 0;
}
</style>